import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const FLEET = [
  { name: "Inyectora 01", meta: "ENGEL · victory 220", loc: "Nave 1", ok: true },
  { name: "Compresor Kaeser", meta: "Kaeser · SD 30", loc: "Sala técnica", ok: true },
  { name: "Robot ABB", meta: "ABB · IRB 4600", loc: "Nave 2", ok: true },
  { name: "Enfriadora", meta: "Frigel · HeavyCool 40", loc: "Nave 1", ok: false },
];

export default function Devices() {
  return (
    <section data-testid="desktop-mobile-comparison">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Desktop + móvil</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            Diseñado para la oficina. Pensado para la fábrica.
          </h2>
          <p className="text-lg text-zinc-600 leading-relaxed mt-5 max-w-2xl">
            Desde el ordenador, los responsables organizan y consultan el parque de máquinas.
            Desde el móvil, un técnico escanea el QR delante del equipo y accede al instante
            a su información.
          </p>
        </div>

        <div className="relative mt-16 lg:mt-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="rounded-3xl border border-zinc-200 bg-white shadow-[0_24px_70px_-20px_rgba(0,0,0,0.15)] overflow-hidden"
          >
            <div className="flex items-center gap-1.5 px-5 py-3.5 border-b border-zinc-100">
              <span className="h-2.5 w-2.5 rounded-full bg-zinc-200" />
              <span className="h-2.5 w-2.5 rounded-full bg-zinc-200" />
              <span className="h-2.5 w-2.5 rounded-full bg-zinc-200" />
              <span className="ml-4 text-xs text-zinc-400 font-mono">assetpassport.app/app</span>
            </div>
            <div className="p-6 sm:p-8 bg-zinc-50/60">
              <div className="h-11 rounded-full bg-white border border-zinc-200 flex items-center px-5 text-sm text-zinc-400 mb-6 max-w-md">
                Buscar máquina, fabricante, modelo o número de serie…
              </div>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {FLEET.map((m) => (
                  <div key={m.name} className="bg-white rounded-2xl border border-zinc-200/80 p-4">
                    <span className={`inline-flex items-center gap-1.5 text-[10px] font-medium px-2 py-0.5 rounded-full ${m.ok ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                      <span className={`h-1 w-1 rounded-full ${m.ok ? "bg-emerald-500" : "bg-amber-500"}`} />
                      {m.ok ? "Operativa" : "Mantenimiento"}
                    </span>
                    <p className="font-medium text-sm text-zinc-900 mt-2.5">{m.name}</p>
                    <p className="text-xs text-zinc-400 mt-0.5">{m.meta}</p>
                    <p className="text-xs text-zinc-400 mt-1 flex items-center gap-1"><MapPin size={10} /> {m.loc}</p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="sm:absolute sm:-bottom-10 sm:right-6 lg:right-14 mt-8 sm:mt-0 mx-auto sm:mx-0 w-[220px]"
          >
            <div className="rounded-[2.2rem] border border-zinc-300 bg-zinc-950 p-2.5 shadow-2xl">
              <div className="rounded-[1.8rem] bg-white p-4 min-h-[300px]">
                <div className="h-20 rounded-xl bg-zinc-100 mb-3 overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1579803165101-cfc62dfdbe45?crop=entropy&cs=srgb&fm=jpg&q=85&w=300"
                    alt="Pasaporte en móvil"
                    className="h-full w-full object-cover"
                    loading="lazy"
                  />
                </div>
                <span className="inline-flex items-center gap-1 text-[10px] font-medium text-emerald-700">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Operativa
                </span>
                <p className="font-heading font-bold text-sm tracking-tight mt-1">INYECTORA 01</p>
                <p className="text-[11px] text-zinc-500">ENGEL · victory 220</p>
                <div className="mt-3 space-y-1.5">
                  {["Resumen", "Documentos", "Historial", "Fotos"].map((t) => (
                    <div key={t} className="rounded-lg bg-zinc-100 px-2.5 py-1.5 text-[10px] font-medium text-zinc-600">{t}</div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
